import AxiosClient from './client';
import { InitiateNetworkInstanceInterface } from './types';

class NetworkInstanceProvider extends AxiosClient {
  private static AxiosClientInstance: NetworkInstanceProvider;
  private static AxiosClientProtectedInstance: NetworkInstanceProvider;

  public static initiateNetworkInstance: InitiateNetworkInstanceInterface = ({
    baseURL,
    isProtected,
  }) => {
    if (isProtected && !this.AxiosClientProtectedInstance) {
      this.AxiosClientProtectedInstance = new AxiosClient({
        HTTPClientParams: { baseURL },
        isProtected,
      });
    }
    if (!this.AxiosClientInstance) {
      this.AxiosClientInstance = new AxiosClient({
        HTTPClientParams: { baseURL },
        isProtected,
      });
    }
    return isProtected
      ? this.AxiosClientProtectedInstance.instance
      : this.AxiosClientInstance.instance;
  };
}

export default NetworkInstanceProvider;
